import React from 'react';
import Icon from 'component/Icon';
import styles from './index.module.scss';

interface IProps {
  iconType: string;
  iconSize?: number;
  customerClass?: string;
  childrenClass?: string;
  title?: string; // 用文字替换icon需求
  titleClass?: string;
}

const MsgItem: React.FunctionComponent<IProps> = ({ iconType, iconSize = 24, customerClass, childrenClass = styles.children, children, title, titleClass }) => {
  return (
    <div className={`${styles.wrapper} ${customerClass}`}>
      {title
        ? (
        <div className={`${styles.title} ${titleClass}`}>{title}</div>
          )
        : (
        <div className={styles.icon}>
          <Icon type={iconType} size={iconSize} />
        </div>
          )}
      <div className={childrenClass}>{children}</div>
    </div>
  );
};

export default MsgItem;
